// extracted by mini-css-extract-plugin
export var locationCard = "_r8-0";